// A refused save above a deal form (useSaveRefusal.js), with a way to read the deal again when
// someone else saved it since.

export default function SaveRefusal({ refusal, onReload }) {
  if (!refusal) return null;
  return (
    <p className="error">
      {refusal.message}
      {refusal.stale && onReload && (
        <> <button type="button" className="link-button" onClick={onReload}>Reload</button></>
      )}
    </p>
  );
}
